import { GET_BIKE_MODELS_LEAD_CREATE_REQUEST, GET_BIKE_MODELS_LEAD_CREATE_REQUEST_SUCCESS, GET_BIKE_MODELS_LEAD_CREATE_REQUEST_FAILURE } from '../constants/get_bike_models.constants';

export const getBikeModelsRequest = params => ({
    type: GET_BIKE_MODELS_LEAD_CREATE_REQUEST,
    params,
});

export const getBikeModelsSuccess = payload => ({
    type: GET_BIKE_MODELS_LEAD_CREATE_REQUEST_SUCCESS, payload,
});

export const getBikeModelsFailure = error => ({
    type: GET_BIKE_MODELS_LEAD_CREATE_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/actions/get_bike_models.actions.js